import { useTableNav } from '@table-nav/react';
import type { ColumnDef } from '@tanstack/react-table';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from '@tanstack/react-table';
import cx from 'classnames';
import React from 'react';

import styles from './grid.module.scss';

interface GridData {
  data: Record<string, unknown>[];
  columns: ColumnDef<any, any>[];
  className: string;
}

export default function Grid({ data, columns, className }: GridData) {
  // TODO CCRA-37242
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });
  const { listeners } = useTableNav();
  return (
    <table className={cx('table', className)} {...listeners}>
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th
                key={header.id}
                tabIndex={0}
                colSpan={header.colSpan}
                className={styles.gridHeader}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <td role="gridcell" tabIndex={0} key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
